import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, patch, post } from './agent';

const exchangeRatePeriods =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'exchange-rate-periods', id]).compact().join('/');

    return {
      get: (query = {}, config) => get(url.concat(new QueryString(query).toString(true)), config),
      upsert: (body) => (id ? patch : post)(url, body),
      delete: () => del(url),
    };
  };

export default exchangeRatePeriods;
